module.exports = __webpack_public_path__ + "static/media/no-itm.3c45da23.png";